import { Modal as AntdModal } from "antd";

import React from "react";

const Modal = (props) => {
  return <AntdModal {...props} />;
};

export default React.memo(Modal);
